module.exports = __webpack_public_path__ + "img/404.e2a961b2.png";